import { Typography } from '@material-ui/core';
import { hasAdminAccess, SupplierProfile } from '@tripr/common';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { SupplierApi } from '../../api/RpcClient';
import { useAuthContext } from '../../utils/AuthContext';
import { useToast } from '../../utils/Utils';
import { SupplierProfileForm, SupplierProfileValues } from './SupplierProfileForm';

export const SupplierAddPage: React.FC = () => {
  const history = useHistory();
  const [callWithToast] = useToast('supplier');
  const authContext = useAuthContext();

  if (!authContext.isLoggedIn || !hasAdminAccess(authContext.account.accountType)) {
    return null;
  }

  return (
    <div>
      <Typography gutterBottom variant="h2">
        Add Supplier
      </Typography>
      <SupplierProfileForm
        onSubmit={async (values: SupplierProfileValues) => {
          const newSupplier = values as Omit<SupplierProfile, 'supplierId'>;
          const supplierId = await callWithToast(SupplierApi.createSupplier(newSupplier));
          history.push(`/suppliers/${supplierId.toString()}`);
        }}
      />
    </div>
  );
};
